export default "__VITE_ASSET__Dk04l2YU__"